import api from './client';

export interface BundleDiscount {
  id: number;
  title: string;
  shopify_product_ids: number[];
  discount_percent: number;
  regular_price: number | null;
  bundle_price: number | null;
  discount_code: string;
  created_at: string | null;
}

export const MIN_BUNDLE_PRODUCTS = 2;
export const MAX_BUNDLE_PRODUCTS = 5;

export interface CreateBundlePayload {
  shopify_product_ids: number[];
  discount_percent: number;
  title: string;
}

export const bundlesApi = {
  list: (page = 1) =>
    api.get<{ data: BundleDiscount[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/bundles?page=${page}`
    ),

  create: (payload: CreateBundlePayload) =>
    api.post<{ data: BundleDiscount }>('/bundles', payload),

  destroy: (id: number) => api.delete(`/bundles/${id}`),
};
